<template>
    <div class="xl:grid grid-cols-3 justify-center items-center space-y-4 xl:space-y-0 xl:gap-x-4">
        <div
            v-for="(plan, index) in pricingCardsData"
            :key="index"
            :class="pricingCardContainer(plan.name)"
            class="text-gray-100 text-center rounded-3xl relative overflow-hidden"
        >
            <div
                class="bg-gray-950 rounded-3xl px-[15px] py-6"
                :class="[activeCycle === 'monthly' ? 'xl:h-[660px]' : 'xl:h-[725px]']"
            >
                <div class="relative h-full z-10">
                    <PlansCardsBgColored :plan-name="plan.name" />
                    <PlansCardsMobile v-if="useDevice().isMobileOrTablet" :plan-details="plan" />
                    <PlansCardsDesktop :plan-details="plan" />
                    <PlansCardsSubscribeButton
                        :plans-details="plan"
                        :plan-transition-type="usePricePackageOfPlan(plan).pricePackage.plan_transition_type"
                    />
                    <PlansCardsAmountPerPhoto
                        v-if="useDevice().isDesktop"
                        :amount-per-photos="usePricePackageOfPlan(plan).pricePackage.amount_per_photo"
                        :symbol="usePricePackageOfPlan(plan).pricePackage.symbol"
                    />
                    <div class="w-full h-[1px] my-4 bg-gray-800 hidden xl:block"></div>
                    <PlansCardsFeatures
                        :features="usePricingData(plan.enterprise, plan.cycle, plan.backup_storage).currentPlanFeatures"
                        :roll-over="plan.roll_over"
                        :is-enterprise="plan.enterprise"
                        :cycle="plan.cycle"
                        :backup-storage="plan.backup_storage"
                    />

                    <PlansCardsBilledYearly
                        v-if="plan.cycle === 'yearly'"
                        :amount="usePricePackageOfPlan(plan).pricePackage.amount"
                        :symbol="usePricePackageOfPlan(plan).pricePackage.symbol"
                        class="absolute bottom-0 mx-auto w-full mt-4"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePricePackageOfPlan } from "../../composables/use-price-package-of-plan";
import { usePricingData } from "../../data";
import type { TActivePlanNames } from "../../types";

const { pricingCardsData, activeCycle } = storeToRefs(usePricingStore());

const pricingCardContainer = (planName: TActivePlanNames) => {
    const bgColorList: Record<TActivePlanNames, string> = {
        standard: "bg-gradient-to-b from-[#DBA34F00] to-[#DBA34F80] p-[1px]",
        pro: "bg-gradient-to-b from-[#FF85B100] to-[#FF85B180] p-[1px]",
        "pro-plus": "bg-gradient-to-b from-[#4D4DBD00] to-[#4D4DBD] p-1",
        enterprise: "bg-gradient-to-b from-[#FFFFFF00] to-[#FFFFFF80] to-50% p-[1px]",
    };
    return bgColorList[planName] || "";
};
</script>
